var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vertical"}},[_c(_vm.cp,{tag:"component",attrs:{"id":_vm.id},on:{"enterCp":_vm.enterCp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }